import { Route, Router } from "wouter-preact";
import { useHashLocation } from "wouter-preact/use-hash-location";
import { RedirectPage } from "./redirect/redirect.tsx";
import { LoginPage } from "./login/login.tsx";
import { MakeVideoPage } from "./make_video/make_video.tsx";
import { ComparePhotoPage } from "./compare_photo/compare_photo.tsx";
import type { FunctionComponent } from "preact";
import { OverviewPage } from "./overview/overview.tsx";
import { CamerasPage } from "./cameras/cameras.tsx";
import { CameraManagerPage } from "./camera_manager/camera_manager.tsx";
import { OSSListPage } from "./oss/oss.tsx";
import { OSSManagerPage } from "./oss_manager/oss_manager.tsx";
import { UserSettingsPage } from "./user_settings/user_settings.tsx";
import { PhotoManagerPage } from "./photo_manager/photo_manager.tsx";
import { CameraSettingPage } from "./camera_setting/camera_setting.tsx";
import { PreviewOverviewPage } from "./preview/preview_overview.tsx";
import { PreviewPhotosPage } from "./preview/preview_photos.tsx";
import { PreviewUserSettingPage } from "./preview/preview_user_setting.tsx";
import { MainLayout } from "../components/layout/main_layout.tsx";
import { AICenterPage } from "./ai_center/ai_center.tsx";
import { BluetoothConfigPage } from "./bluetooth_config/bluetooth_config.tsx";
import { navigate } from "../router_utils.ts";
import { ErrorBoundary } from "../components/error_boundary/error_boundary.tsx";

export { navigate, gotoLoginPage, onClickGotoHandler } from "../router_utils.ts";

const MainLayoutRoute = ({ component: Component, title, fullScreen, ...rest }: any) => {
    return (
        <Route {...rest}>
            {(params) => (
                <MainLayout title={title} fullScreen={fullScreen}>
                    <ErrorBoundary>
                        <Component {...params} />
                    </ErrorBoundary>
                </MainLayout>
            )}
        </Route>
    );
};

export const AppRouter: FunctionComponent = (_) => (
    <Router hook={useHashLocation}>
        <MainLayoutRoute path="/" component={OverviewPage} />
        <MainLayoutRoute path="/overview" component={OverviewPage} />
        <MainLayoutRoute path="/cameras" component={CamerasPage} />
        <MainLayoutRoute path="/camera/new" component={CameraManagerPage} />
        <MainLayoutRoute path="/camera/:id" component={CameraManagerPage} />
        <MainLayoutRoute path="/oss" component={OSSListPage} />
        <MainLayoutRoute path="/oss/new" component={OSSManagerPage} />
        <MainLayoutRoute path="/oss/:id" component={OSSManagerPage} />
        <MainLayoutRoute path="/settings" component={UserSettingsPage} />
        <MainLayoutRoute path="/photos/:cameraId" component={PhotoManagerPage} />
        <MainLayoutRoute path="/camera_setting/:cameraId" component={CameraSettingPage} />
        
        <Route path="/preview/:link" component={PreviewOverviewPage} />
        <Route path="/preview/:link/photos/:cameraId" component={PreviewPhotosPage} />
        <Route path="/preview/:link/settings" component={PreviewUserSettingPage} />
        <Route path="/r/:loc" component={RedirectPage} />
        <MainLayoutRoute path="/make_video" component={MakeVideoPage} />
        <MainLayoutRoute path="/compare_photo" component={ComparePhotoPage} fullScreen={true} />
        <MainLayoutRoute path="/ai_center" component={AICenterPage} />
        <MainLayoutRoute path="/bluetooth" component={BluetoothConfigPage} />
        <Route path="/login" component={LoginPage} />
        {/* ... */}
    </Router>
);
export default AppRouter;
